import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import { EyeIcon } from "@heroicons/vue/24/solid";
import PencilWriteIcon from "@/components/icons/pencilWriteIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ViewButton',
  props: {
    routeLink: {
        type: String,
        required: true,
    },
    customClass: {
        type: String,
    },
    isEyeIcon: {
        type: Boolean,
        default: true
    }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", { href: __props.routeLink }, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["bg-secondary-600 hover:bg-secondary-500 rounded shadow-[0_0_4px_0px_rgb(17,24,39,0.25)] p-[6px] border border-transparent mx-1 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-secondary-600", __props.customClass])
    }, [
      (__props.isEyeIcon)
        ? (_openBlock(), _createBlock(_unref(EyeIcon), {
            key: 0,
            class: "w-5 h-5 text-white",
            "aria-hidden": "true"
          }))
        : (_openBlock(), _createBlock(PencilWriteIcon, {
            key: 1,
            class: "w-5 h-5"
          })),
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 8, _hoisted_1))
}
}

})